import axios from 'axios';
import { apiUrl } from './config';

const MeetingsApi = {
  getMeetingTitles: async () => {
    return axios.get(`${apiUrl}/get-meeting-titles`);
  },
  addMeetingTitle: async (createdBy, title) => {
    return axios.post(`${apiUrl}/add-meeting-title`, {
      createdBy,
      title
    });
  },
  updateMeetingTitle: async (modifiedBy, oldTitle, newTitle) => {
    return axios.put(`${apiUrl}/update-meeting-title`, {
      modifiedBy,
      oldTitle,
      newTitle
    });
  },
};

export default MeetingsApi;
